<template>
<ul :class="'nav nav-' + gradient" role="tablist">
  <li v-for="(tabItem, index) in tabItems" :key="index" @click="onTabSelected(index)" >
    <a :href="tabItem.id" role="tab" data-toggle="tab" :class="{active: index === selectedTab}" >
      <i :class="tabItem.icon"/>
      <p>{{tabItem.label}}</p>
    </a>
  </li>
</ul>
</template>

<script>
export default {
  name: 'tab-list',
  data() {
    return {
      selectedIndex: 0
    }
  },
  props: {
    tabItems: {
      type: Array,
      required: true,
      validator: function(tabItems) {
        return !tabItems.some(
          item => item === null || typeof item !== 'object' || !item.id || !item.icon || !item.label
        )
      }
    },
    selectedTab: {
      type: Number,
      default: 0
    },
    gradient: {
      type: String,
      default: 'gradient-donapp'
    }
  },
  methods: {
    onTabSelected: function(index) {
      this.$emit('tabSelected', index)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/config.scss';

.nav {
  padding-top: 0px;
  margin-top: 0px;
}

.nav li {
  @include borderRadius();
}

.nav li > a {
  margin: 0px 0px 6px;
  @include borderRadius();
  color: #3c4858;
  position: relative;
  display: block;
  padding: $primaryDistance;
}

.nav li a p {
  @include normalFontSize();
  font-weight: 400;
  color: $grey;
  margin-top: 1px;
  line-height: 14px;
}

.nav li a i {
  color: $grey;
  line-height: 16px;
  width: auto;
  @include bigFontSize();
}

.nav i {
  @include bigFontSize();
  float: left;
  margin-right: $primaryDistance;
  text-align: center;
  color: #a9afbb;
}

.nav.nav-gradient-merchant li > a.active {
  @include merchantGradient();
}

.nav.nav-gradient-user li > a.active {
  @include userGradient();
}

.nav.nav-gradient-npo li > a.active {
  @include npoGradient();
}

.nav.nav-gradient-donapp li > a.active {
  @include donappGradient();
}

.nav li > a.active > p {
  color: $white !important;
}

.nav li > a.active > i {
  color: $white !important;
}

.nav li a.active {
  @include shadow();
}

a .material-icons {
  vertical-align: middle;
}

.nav p {
  margin: 0;
  text-align: left;
}

.nav li:hover > a:not(.active) {
  background: rgba(200, 200, 200, 0.2);
  color: #3c4858;
}

// .nav li:first-child > a,
// .off-canvas-sidebar .nav li:first-child > a {
//   margin: 0 15px;
// }

.animation-transition-general,
.nav li > a,
.off-canvas-sidebar .nav li > a {
  -webkit-transition: all 300ms linear;
  -moz-transition: all 300ms linear;
  -o-transition: all 300ms linear;
  -ms-transition: all 300ms linear;
  transition: all 300ms linear;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/TabList.vue